import { translate } from '@avalara/bat-apps-shared/i18n';
import ExternalLink from '../../external-link';

const LicensePrepOfferDetails = () => (
  <div data-ref='buy.offer.custom-offer-details.license-prep-content' className='margin-left-sm'>
    <p>
      <span className='font-bold'>{translate('client.general.note')}: </span>
      {translate('client.general.license-prep-supports-license-requirements-for-non-regulated-businesses-only', {
        businessType: (chunks) => <span className='font-bold'>{chunks}</span>,
      })}
    </p>

    <p className='margin-top-md'>
      {translate('client.general.regulated-businesses-that-require-additional-licensing-steps')}:
    </p>
    <p className='margin-left-xl'>
      <ExternalLink href='https://www.businesslicenses.com/e882_reg_81a'>
        {translate('client.general.regulated-industries')}
      </ExternalLink>
    </p>

    <p className='margin-left-xl'>
      <ExternalLink href='https://www.businesslicenses.com/e882_reg_81d'>
        {translate('client.general.businesses-subject-to-additional-regulated-or-excise-taxes')}
      </ExternalLink>
    </p>

    <p className='margin-top-md'>
      {translate('client.general.for-additional-information-on-regulated-license-requirements')}{' '}
      <a href='tel://8772243650'>877.224.3650</a>.
    </p>
  </div>
);

export default LicensePrepOfferDetails;
